import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  withText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', withText = false, className = '' }) => {
  const { t } = useTranslation();
  
  const sizeClasses = {
    small: 'h-10',
    medium: 'h-16',
    large: 'h-24'
  };

  return (
    <Link to="/" className={`flex items-center ${className}`}>
      <svg 
        className={`${sizeClasses[size]} text-blue-600`}
        viewBox="0 0 501 500" 
        fill="currentColor"
        style={{ transform: 'scale(2.2)' }}
      >
        <g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)">
          <path d="M1370 2926 c-116 -25 -216 -106 -269 -216 -23 -48 -26 -68 -26 -155 0 -88 3 -107 27 -157 35 -76 104 -148 181 -189 59 -33 67 -34 167 -34 88 0 113 4 154 22 l48 23 35 -30 c91 -80 214 11 159 118 -8 15 -23 35 -34 45 -19 17 -19 21 -6 53 60 143 21 319 -92 425 -58 53 -119 85 -193 99 -65 12 -80 12 -151 -4z m166 -235 c46 -28 78 -86 78 -141 0 -131 -155 -205 -260 -125 -122 93 -54 285 100 285 32 0 62 -7 82 -19z"/>
          <path d="M2012 2627 c-52 -19 -103 -66 -124 -115 -30 -66 -22 -157 18 -214 76 -108 245 -124 337 -30 142 146 44 375 -159 371 -22 0 -54 -6 -72 -12z m134 -86 c126 -57 82 -251 -57 -251 -42 0 -55 5 -86 33 -31 29 -37 41 -40 88 -5 65 20 112 70 134 43 19 64 18 113 -4z"/>
          <path d="M2678 2629 c-16 -9 -18 -26 -18 -129 0 -66 -4 -120 -8 -120 -5 0 -39 41 -78 92 -105 140 -123 158 -153 158 -15 0 -32 -5 -39 -12 -15 -15 -17 -360 -2 -389 6 -11 21 -19 35 -19 37 0 45 28 45 149 0 61 3 111 8 110 4 0 51 -58 105 -130 75 -99 103 -129 120 -129 44 0 47 13 47 217 0 180 -1 193 -19 203 -23 12 -22 12 -43 -1z"/>
          <path d="M2890 2627 c-65 -22 -98 -107 -68 -172 13 -29 63 -58 118 -70 59 -13 90 -33 90 -60 0 -13 -5 -27 -12 -31 -24 -15 -96 -7 -132 14 -46 27 -72 28 -86 2 -16 -30 2 -54 61 -80 42 -18 66 -21 121 -18 61 3 72 7 101 36 28 29 32 39 32 88 0 49 -4 59 -28 80 -15 13 -59 33 -98 45 -94 28 -116 51 -83 83 20 20 64 20 111 1 48 -20 70 -19 83 5 9 16 6 25 -13 44 -42 42 -128 57 -197 33z"/>
          <path d="M3285 2616 c-59 -27 -77 -46 -104 -106 -40 -88 -19 -185 54 -248 48 -43 77 -54 147 -55 77 0 142 33 184 95 61 90 52 193 -25 269 -72 72 -164 89 -256 45z m150 -70 c45 -19 75 -69 75 -124 0 -78 -52 -132 -127 -132 -138 0 -183 188 -59 250 49 24 65 25 111 6z"/>
        </g>
      </svg>
      {withText && (
        <span className={`ml-2 font-bold text-gray-900 ${sizeClasses[size]}`}>
          {t('appName')}
        </span>
      )}
    </Link>
  );
};

export default Logo;